import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import { forwardRef, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import Icon from '@locus-labs/mol-mobile-icon';
import styledSystemPropTypes from '@styled-system/prop-types';
import { compose, background, border, color, layout, position, shadow, space, typography } from 'styled-system';
import { theme, prop } from 'styled-tools';
import { jsx } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const StyledFloatingActionButton = styled('button').withConfig({
  displayName: "floating-action-button__StyledFloatingActionButton",
  componentId: "sc-7g888e-0"
})(["display:flex;align-items:center;justify-content:center;box-shadow:", ";padding:0;width:40px;height:40px;border:none;border-radius:", ";background-color:", ";-webkit-tap-highlight-color:rgba(0,0,0,0);&:focus-visible{outline:1px solid orange;outline-offset:2px;}&:active{outline:none;border:none;box-shadow:", ";svg{fill:", ";}}&:hover{cursor:pointer;}", ""], theme('shadows.md'), theme('radii.full'), theme('colors.background'), theme('shadows.lg'), prop('iconTapColor', theme('colors.primaryText')), compose(background, border, color, layout, position, shadow, space, typography));
const FloatingActionButton = /*#__PURE__*/forwardRef((props, ref) => {
  const themeContext = useContext(ThemeContext);
  return /*#__PURE__*/jsx(StyledFloatingActionButton, _objectSpread(_objectSpread({
    "data-cy": "FloatingActionButton",
    ref: ref,
    "aria-label": props.ariaLabel || typeof props.children === 'string' && props.children || ''
  }, props), {}, {
    children: /*#__PURE__*/jsx(Icon, {
      "data-cy": "Icon",
      name: props.iconName,
      iconSize: "md",
      color: props.iconColor || themeContext.colors.secondaryText,
      degreesOfIconRotation: props.degreesOfIconRotation
    })
  }));
});
FloatingActionButton.displayName = 'Floating Action Button';
FloatingActionButton.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  degreesOfIconRotation: PropTypes.number,
  iconColor: PropTypes.string,
  iconTapColor: PropTypes.string,
  isRippleClickEffectCentered: PropTypes.string,
  ariaLabel: PropTypes.string
});

export default FloatingActionButton;
